module.exports = __webpack_public_path__ + "static/media/Suggested_Fruits_Button.1a172983.svg";